<template>
    <div class="filling-goods-div">
      <div style="padding-top: 5px; font-size: 16px">待发货列表</div>
      <div class="order-goods-head">
        <div class="order-head-div">
          <div class="time-input-div">
            <input class="time-input" placeholder="开始时间" @click="DatePicker(0)" v-model="startDate" readonly="readonly"
              type="datetime" />
            <van-popup v-model="showPicker" position="bottom">
              <van-datetime-picker v-model="tempDate" type="datetime" @confirm="hideDatePicker"
                @cancel="cancelDatePicker"></van-datetime-picker>
            </van-popup>
          </div>
          <div class="time-input-div">
            <input class="time-input" placeholder="结束时间" @click="DatePicker(1)" v-model="endDate" readonly="readonly"
              type="datetime" />
          </div>
        </div>
        <div class="order-head-div">
          <div class="time-input-div">
            <!-- <div style="width: 50%; text-align: left">供应商:</div> -->
            <input class="time-input" placeholder="搜索装箱单" v-model="out_num" @keyup.enter="SearchOrder()" />
          </div>
          <div class="time-input-div">
            <input class="time-input" placeholder="搜索客户名" name="normsware" v-model="client_name"
              @keyup.enter="SearchName()" />
          </div>
        </div>
      </div>
  
      <span style="color: red" v-if="hostcs">测试服</span>
      <!-- <div
          style="display: flex; justify-content: space-between; align-items: center"
          v-if="outNumber === '未出库'"
        >
        </div> -->
      <div :style="style" @scroll="onScroll">
        <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> -->
        <div class="order-out" v-for="(i, index) in data" :key="index" @click="go_pick(index)">
          <div class="info-outdata" :class="{ 'full-width': shouldUseWidth(i.out_num) }">
            <div style=" text-align: left">装箱单号:{{ i.packing_num }}</div>
          </div>
          <div class="info-outdata" :class="{ 'full-width': shouldUseWidth(i.affirm_time) }">
            <div style=" text-align: left">客户名:{{ i.kh_name }}</div>
          </div>
          <div class="info-outdata" :class="{ 'full-width': shouldUseWidth(i.zps) }">
            <div style=" text-align: left">总匹数:{{ i.zps }}</div>
          </div>
          <div class="info-outdata" :class="{ 'full-width': shouldUseWidth(i.pi) }">
            <div style=" text-align: left">已扫匹数:{{ i.ysps }}</div>
          </div>
          <div class="info-outdata" :class="{ 'full-width': shouldUseWidth(i.remark) }">
            <div style=" text-align: left">备注:{{ i.remark }}</div>
          </div>
        </div>
        <div v-if="!finished" style="font-size: 16px;color: #b9b9b9;align-items: center;padding: 10px;text-align: center;">
          没有更多了
        </div>
        <!-- </van-list> -->
      </div>
      <div class="filling-bottom-button" style="display: flex">
        <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
      </div>
    </div>
  </template>
    
  <script>
  import $ from "jquery";
  import { mapState, mapMutations } from "vuex";
  import { Dialog } from "vant";
  import { Toast } from "vant";
  import axios from 'axios';
  import { DatetimePicker } from 'vant';
  import moment from 'moment';
  export default {
    name: "FabricOutList",
    data() {
      return {
        hostcs: false,
        ray: "扫描中",
        id: "",
        style: "",
        reeldata: "",
        infoType: "1111",
        outNumber: "未出库",
        username: "",
        type: "orderInfo",
        //xin
        isDate: 0,
        showPicker: false,
        startDate: '',
        endDate: '',
        tempDate: new Date(),
        client_name: "",
        out_num: "",
        list: [],
        data: [],
        maxByteLength: 30,
        loading: false,
        finished: true,
        page: 1,
        configurl: window.localStorage.getItem('pdaBASEURL'),
      };
    },
    mounted() {
      this.username = JSON.parse(window.localStorage.getItem("userinfo"));
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.style =
        "text-align: left;width: 100%;max-height: " + h * 0.8 + "px;overflow: scroll;";
      //   setTimeout(() => {      }, 500);
      if (window.location.host.indexOf("cspda") !== -1) {
        this.hostcs = true;
      }
      this.Order();
    },
    computed: {
      shouldUseWidth() {
        return (value) => {
          const encoder = new TextEncoder();
          const bytes = encoder.encode(value);
          const byteLength = bytes.length;
          //console.log(value,bytes.length)
          return byteLength > this.maxByteLength;
        };
      }
    },
    methods: {
      onScroll(e) {  //下拉加载数据
        const bottomOfList = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottomOfList && this.finished) {
          this.Order();
        }
      },
      DatePicker(index) {
        this.showPicker = true;
        this.isDate = index;
      },
      cancelDatePicker() {
        this.showPicker = false;
      },
      hideDatePicker() {
        this.showPicker = false;
        if (this.isDate) {
          this.endDate = moment(this.tempDate).format('YYYY-MM-DD HH:mm:ss');
        } else {
          this.startDate = moment(this.tempDate).format('YYYY-MM-DD HH:mm:ss');
        };
        //进行时间判断，符合条件开始筛选
        if (this.endDate < this.startDate && this.endDate !== '') {
          Dialog.alert({
            message: "开始时间不能大于结束时间!",
          });
          this.endDate = '';
        } else {
          this.page = 1;
          this.data = [];
          this.Order();
        }
      },
      async Order() {
        //this.finished = false;
        await axios.get(this.configurl+this.APIOBJ.outListZp, {
          params:{
            start_time: this.startDate,
            end_time: this.endDate,
            out_num: this.out_num,
            client_name: this.client_name,
            page: this.page,
          },
          timeout:15000,
        }).then(
          (res) => {
            if (res.data.status == 1) {
              console.log(res.data.data)
              this.list = res.data.data.data;
              this.list.map((i) => {
                this.data.push(i)
              })
              if (this.list.length === 0) {
                this.finished = false;
              } else {
                this.page++;
                this.finished = true;
              }
            } else 
            { 
              Toast(res.data.msg); 
            }
          }
        )
      },
      SearchOrder() {
        this.data = [];
        this.page = 1;
        this.Order();
      },
      SearchName() {
        this.data = [];
        this.page = 1;
        this.Order();
      },
      // onLoad() {
      //   // 异步更新数据
      //   console.log('ss+', this.data.length, this.page)
      //   setTimeout(() => {
      //     this.page++
      //     this.loading = false;
      //     this.SearchOrder()
      //     // 加载状态结束
      //   }, 1000);
      // },
      go_pick(i) {
        this.$router.push({ path: "/FabricOutDetail", query: { out_num: this.data[i].packing_num , out_id: this.data[i].id} });
      },
      // gourl(url) {
      //   url = "http://www.lcyjfz.com/home/scan?url=" + url;
      //   window.location.href = url;
      // },
      go_index() {
        Dialog.confirm({
          message: "确定要回首页吗？",
        })
          .then(() => {
            this.$router.push("/home");
          })
          .catch(() => {
            // on cancel
          });
      },
      go_scan_url() {
        let url =
          "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
        window.location.href = url;
      },
    },
  };
  </script>
    
  <style lang="less">
  @import "../style/outOrderInfo.less";
  
  .info-outdata {
    display: flex;
    padding: 10px 0px 10px 0px;
    align-items: center;
    //justify-content: center;
    width: 50%;
  }
  
  .filling-bottom-button {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-left: -10px;
  }
  
  .order-head-div {
    display: flex;
    width: 100%;
    padding: 5px 0;
    justify-content: space-around;
  }
  
  .order-goods-head {
    padding: 20px 0;
  }
  
  .time-input-div {
    display: flex;
    /* width: 100%; */
    align-items: center;
    position: relative;
  }
  
  .time-input {
    width: 100%;
    text-align: center;
  }
  
  .time-input::placeholder {
    text-align: center;
  }
  
  .order-out {
    //padding: 3%;
    border-bottom: 1px solid #444444;
    display: flex;
    flex-wrap: wrap;
    margin: 3%;
    padding-bottom: 20px;
  }
  
  .full-width {
    width: 100%;
  }
  </style>